import { useContext } from 'react'
import { Box, Typography } from '@mui/material'
import { format, parseISO } from 'date-fns'

// Local imports
import SingleStepper from 'components/reusable/AdxProgressStepper/SingleStepper'
import { authContext } from 'contexts/AuthContext'
import DefaultAvatar from 'assets/images/default_avatar.png'

const RequestApproval = ({ approvalArr, requestItem }) => {
  const { data: authData } = useContext(authContext).auth
  const safeApprovalArr = Array.isArray(approvalArr) ? approvalArr : []
  const [submittedLayer, ...remainingLayer] = approvalArr || []
  const myName = authData?.staff?.name

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="body1" color="text.quaternary">
        Progress
      </Typography>
      <Box>
        <SingleStepper
          active={true}
          activeSubtitle={
            requestItem?.status === 16 ? (
              <Typography
                noWrap
                component="span"
                variant="body2"
                color={'light-gray-text.main'}
                fontWeight="bold"
                textTransform="capitalize"
              >
                Withdrawn
              </Typography>
            ) : (
              'Submitted'
            )
          }
          name={
            authData?.staff?.name === submittedLayer?.request_from
              ? 'Me'
              : submittedLayer?.request_from
          }
          imgUrl={submittedLayer?.request_from_image || DefaultAvatar}
          date={
            requestItem?.status === 16
              ? format(parseISO(requestItem?.updated_at), `dd/MM/yyyy, hh:mmaa`)
              : submittedLayer?.updated_at
                ? format(parseISO(submittedLayer.updated_at), `dd/MM/yyyy, hh:mmaa`)
                : null
          }
        />
        {remainingLayer.map((item, index, arr) => (
          <SingleStepper
            key={index}
            active={item.approval_status === 17 || item.approval_status === 11 ? true : false}
            activeSubtitle={
              item.approval_status === 11 ? (
                <Typography
                  noWrap
                  component="span"
                  variant="body2"
                  color={'error.main'}
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {item.approval_status_name}
                </Typography>
              ) : (
                item.approval_status_name
              )
            }
            disableLine={remainingLayer.length - 1 === index}
            inactiveSubtitle={
              requestItem.status === 11 || requestItem.status === 16
                ? 'No further action needed'
                : index - 1 >= 0 && arr[index - 1].approval_status === 1
                  ? `Awaiting approval by previous layer`
                  : 'Awaiting approval'
            }

            name={
              (() => {
                const isDone = item?.approval_status === 17 || item?.approval_status === 11

                // if approver is missing/null, fallback to []
                const approvers = Array.isArray(item?.approver) ? item.approver.filter(Boolean) : []

                if (isDone) return item?.approved_by || '-'

                const names = approvers
                  .map((el) => (el?.name === myName ? 'Me' : el?.name))
                  .filter(Boolean)

                return names.length ? names.join(', ') : '-'
              })()
            }
            imgUrl={
              (() => {
                const isDone = item?.approval_status === 17 || item?.approval_status === 11

                if (isDone) return item?.approved_by_image || DefaultAvatar

                const approvers = Array.isArray(item?.approver) ? item.approver.filter(Boolean) : []
                const firstImg = approvers?.[0]?.image

                return firstImg || DefaultAvatar
              })()
            }

            date={item.updated_at ? format(parseISO(item.updated_at), `dd/MM/yyyy, hh:mmaa`) : null}
          />
        ))}
      </Box>
    </Box>
  )
}

export default RequestApproval
